import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import './i18n'
import { router } from './routes'

function applyInitialTheme() {
  const root = document.documentElement
  const raw = window.localStorage.getItem('morpherd_settings')

  let themePreference: 'system' | 'light' | 'dark' = 'system'

  if (raw) {
    try {
      const parsed = JSON.parse(raw) as { state?: { themePreference?: 'system' | 'light' | 'dark' }; themePreference?: 'system' | 'light' | 'dark' }
      themePreference = parsed.state?.themePreference ?? parsed.themePreference ?? 'system'
    } catch {
      themePreference = 'system'
    }
  }

  const resolvedTheme =
    themePreference === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : themePreference

  root.setAttribute('data-theme', resolvedTheme)
  root.classList.toggle('dark', resolvedTheme === 'dark')
}

applyInitialTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
